import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  top: 0;
  left: 0;
`

export default Container
